import httpClient from "../../../shared/api/httpClient";

// As rotas de leitura devolvem a lista de alertas já atualizada (mesmo formato de list).
const dados = (r) => r.data.dados ?? [];

export const alertasApi = {
  list: () => httpClient.get("/api/v1/alertas").then(dados),
  markRead: (id) => httpClient.post(`/api/v1/alertas/${encodeURIComponent(id)}/lido`).then(dados),
  markUnread: (id) => httpClient.delete(`/api/v1/alertas/${encodeURIComponent(id)}/lido`).then(dados),
  markAllRead: () => httpClient.post("/api/v1/alertas/lidos").then(dados),
};
